/**
 * SAT Akademie — zentraler Veröffentlichungsstatus.
 * Alle Bereiche bleiben live erreichbar (keine Löschungen); ihre öffentliche
 * Sichtbarkeit (Nav, Home-Sektionen, Verkaufs-CTAs, Sitemap) wird hier gesteuert.
 *
 * MVL = Minimum Viable Launch (Stufe 1).
 */
export const LAUNCH_MODE = "MVL"; // "MVL" | "FULL"

export const PUBLIC_SURFACE = {
  master:        true,   // /sat-master
  mentor:        true,   // /mentor
  herzbewegung:  true,   // /herzbewegung
  htc:           true,   // /sat-htc (Methode, roter Faden)
  about:         true,   // /about
  erstgespraech: true,   // /erstgespraech (Haupt-CTA)
  stimmen:       true,   // /stimmen (Sammelseite, kompakt im Footer)

  // ---- weiterhin live, aber nicht öffentlich vermarktet ----
  academy:       false,  // Kurskatalog
  programme:     false,  // Programme
  ecosystem:     false,  // SAT Ecosystem/Corporate/SATUNITY
  partners:      false,  // Partner-Projekte / Wall
  los:           false,  // Life Operating System
  lebensrad:     false,  // SAT-HPA / Lebensrad
  satapp:        false,
  ai:            false,  // AMARA AI
  tv:            false,
  podcast:       false,
  quiz:          false,
  forum:         false,
  events:        false,
  referrals:     false,
  thirty_rules:  false,  // /30-spielregeln (existierender Lead-Magnet)
};

/**
 * Zeigt ob ein öffentliches Preisschild angezeigt werden darf.
 * Bis zur ausdrücklichen Preisfreigabe: nein.
 */
export const PRICING_PUBLIC = false;

/** Wird der Stripe-Live-Modus verwendet? Bleibt false bis GO LIVE des Users. */
export const STRIPE_LIVE_MODE = false;

/**
 * Analytics — via ENV opt-in. Wenn REACT_APP_PLAUSIBLE_DOMAIN nicht gesetzt ist,
 * wird Plausible nicht geladen. Kein Auto-Konto, kein Auto-Snippet.
 */
export const ANALYTICS = {
  plausibleDomain: process.env.REACT_APP_PLAUSIBLE_DOMAIN || "",
};

/**
 * Erstgesprächs-Kalender. Wenn leer → Fallback auf Formular-Only Flow.
 */
export const CALENDAR_URL = process.env.REACT_APP_CALENDAR_URL || "https://calendly.com/good-life-impuls/30min";
